export default "__VITE_ASSET__16bba5a6__"